import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/style/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {store} from "./store/store";
import { Provider } from 'react-redux';
import { GlobalContextProvider } from './contexts';
import { ConfigProvider } from 'antd';

import moment from 'moment';
import 'moment/locale/ru'
import ruRU from 'antd/es/locale/ru_RU';

moment.locale('ru')

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <GlobalContextProvider>
                <ConfigProvider locale={ruRU}>
                    <App/>
                </ConfigProvider>
            </GlobalContextProvider>
        </BrowserRouter>
    </Provider>
);

reportWebVitals();
